module.exports = __webpack_public_path__ + "img/Mover_Front_Side_Right_Transparent.8d1f9f1d.svg";